import React, { useState } from 'react';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/7jf1fq47_IMG_8942.jpeg"
              alt="Kove Logo"
              className="h-12 w-12 rounded-full object-cover ring-2 ring-sage-600"
            />
            <div>
              <h1 className="text-xl font-serif text-sage-700 tracking-wide">KOVE</h1>
              <p className="text-xs text-gray-500 tracking-wider">THE STUDIO</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-sage-600 transition-colors duration-200 font-light tracking-wide"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-gray-700 hover:text-sage-600 transition-colors duration-200 font-light tracking-wide"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-sage-600 transition-colors duration-200 font-light tracking-wide"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-sage-600 transition-colors duration-200 font-light tracking-wide"
            >
              Contact
            </button>
            <a
              href="sms:0475409162"
              className="bg-sage-600 text-white px-6 py-2.5 rounded-full hover:bg-sage-700 transition-all duration-200 font-light tracking-wide shadow-md"
            >
              Book Now
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-sage-700 hover:text-sage-800 transition-colors duration-200 p-2"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-sage-100 bg-white shadow-lg overflow-hidden animate-slideDown">
            <div className="flex flex-col space-y-4 px-2">
              <button onClick={() => scrollToSection('services')} className="text-left text-gray-700 hover:text-sage-600 transition-colors duration-200 py-2 px-3 rounded-md hover:bg-sage-50 font-light">
                Services
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-left text-gray-700 hover:text-sage-600 transition-colors duration-200 py-2 px-3 rounded-md hover:bg-sage-50 font-light">
                Gallery
              </button>
              <button onClick={() => scrollToSection('about')} className="text-left text-gray-700 hover:text-sage-600 transition-colors duration-200 py-2 px-3 rounded-md hover:bg-sage-50 font-light">
                About
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-sage-600 transition-colors duration-200 py-2 px-3 rounded-md hover:bg-sage-50 font-light">
                Contact
              </button>
              <a href="sms:0475409162" className="bg-sage-600 text-white px-6 py-3 rounded-full text-center hover:bg-sage-700 transition-colors duration-200 mt-2 font-light shadow-md">
                Book Now
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;